const modelList = {
    RP553K: [
        {
            appName: 'Maths Tutor',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk'
        },
        {
            appName: 'Seesaw',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK'
        },
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://dl.dropboxusercontent.com/s/83aapgt9uj975np/ESareTV_v3.0.415_signed_828.apk?dl=0'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl: 'https://dl.dropboxusercontent.com/s/fpjttoogmpwpef0/iMirror.apk?dl=0'
        },
        {
            appName: 'Preschool and Kindergarten Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk'
        },
        {
            appName: 'Preschool and Kindergarten 2: Extra Lessons',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk'
        },
        {
            appName: 'First Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk'
        },
        {
            appName: 'Second Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk'
        },
        {
            appName: 'Third Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fourth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fifth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Sixth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk'
        },
        {
            appName: '7th Grade Math Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk'
        },
        {
            appName: 'Bingo for Kids',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl: 'https://download.teamviewer.com/blizz/android/TeamViewerBlizz.apk'
        },
        {
            appName: 'Broadcast Setting',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'TeamViewer QuickSupport',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png',
            downloadUrl: 'https://download.teamviewer.com/download/TeamViewerQS.apk'
        },
        {
            appName: 'BenQ Keyboard V1',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk'
        },
        {
            appName: 'QOTA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/wqVfZV.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/761/QOtaClient_v2.0.3.12_V510_production.apk'
        }
    ],
    RP653K: [
        {
            appName: 'InstaQPrint',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
        },
        {
            appName: 'Maths Tutor',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk'
        },
        {
            appName: 'Seesaw',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK'
        },
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://dl.dropboxusercontent.com/s/83aapgt9uj975np/ESareTV_v3.0.415_signed_828.apk?dl=0'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl: 'https://dl.dropboxusercontent.com/s/fpjttoogmpwpef0/iMirror.apk?dl=0'
        },
        {
            appName: 'Preschool and Kindergarten Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk'
        },
        {
            appName: 'Preschool and Kindergarten 2: Extra Lessons',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk'
        },
        {
            appName: 'First Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk'
        },
        {
            appName: 'Second Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk'
        },
        {
            appName: 'Third Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fourth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fifth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Sixth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk'
        },
        {
            appName: '7th Grade Math Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk'
        },
        {
            appName: 'Bingo for Kids',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl: 'https://download.teamviewer.com/blizz/android/TeamViewerBlizz.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'TeamViewer QuickSupport',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png',
            downloadUrl: 'https://download.teamviewer.com/download/TeamViewerQS.apk'
        },
        {
            appName: 'BenQ Keyboard V1',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk'
        },
        {
            appName: 'QOTA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/wqVfZV.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/761/QOtaClient_v2.0.3.12_V510_production.apk'
        }
    ],
    RP654K: [
        {
            appName: 'InstaQPrint',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
        },
        {
            appName: 'Maths Tutor',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk'
        },
        {
            appName: 'Seesaw',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK'
        },
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20221230/InstaShareRX_IFP_v1.4.1228-RE03-RM02-CP01-signed.apk'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/730/EAirPlay_8.11.6-benqpdp-release.apk'
        },
        {
            appName: 'Preschool and Kindergarten Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk'
        },
        {
            appName: 'Preschool and Kindergarten 2: Extra Lessons',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk'
        },
        {
            appName: 'First Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk'
        },
        {
            appName: 'Second Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk'
        },
        {
            appName: 'Third Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fourth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fifth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Sixth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk'
        },
        {
            appName: '7th Grade Math Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk'
        },
        {
            appName: 'Bingo for Kids',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl: 'https://download.teamviewer.com/blizz/android/TeamViewerBlizz.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'BenQ Keyboard V1',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk'
        },
        {
            appName: 'QOTA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/wqVfZV.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/761/QOtaClient_v2.0.3.12_V510_production.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        }
    ],
    RP704K: [
        {
            appName: 'InstaQPrint',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
        },
        {
            appName: 'Maths Tutor',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk'
        },
        {
            appName: 'Seesaw',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK'
        },
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20221230/InstaShareRX_IFP_v1.4.1228-RE03-RM02-CP01-signed.apk'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl: 'https://www.dropbox.com/s/6hfsso4xw38ukbp/iMirror_6.5.24.apk?dl=1'
        },
        {
            appName: 'Preschool and Kindergarten Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk'
        },
        {
            appName: 'Preschool and Kindergarten 2: Extra Lessons',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk'
        },
        {
            appName: 'First Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk'
        },
        {
            appName: 'Second Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk'
        },
        {
            appName: 'Third Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fourth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fifth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Sixth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk'
        },
        {
            appName: '7th Grade Math Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk'
        },
        {
            appName: 'Bingo for Kids',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl: 'https://download.teamviewer.com/blizz/android/TeamViewerBlizz.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'BenQ Keyboard V1',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk'
        },
        {
            appName: 'QOTA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/wqVfZV.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/761/QOtaClient_v2.0.3.12_V510_production.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'OfficeSuite',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/lhItsY.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/OfficeSuite.apk'
        }
    ],
    RP750K: [
        {
            appName: 'InstaQPrint',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
        },
        {
            appName: 'Maths Tutor',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk'
        },
        {
            appName: 'Seesaw',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK'
        },
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20221230/InstaShareRX_IFP_v1.4.1228-RE03-RM02-CP01-signed.apk'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/730/EAirPlay_8.11.6-benqpdp-release.apk'
        },
        {
            appName: 'Preschool and Kindergarten Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk'
        },
        {
            appName: 'Preschool and Kindergarten 2: Extra Lessons',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk'
        },
        {
            appName: 'First Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk'
        },
        {
            appName: 'Second Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk'
        },
        {
            appName: 'Third Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fourth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fifth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Sixth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk'
        },
        {
            appName: '7th Grade Math Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk'
        },
        {
            appName: 'Bingo for Kids',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl: 'https://download.teamviewer.com/blizz/android/TeamViewerBlizz.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'BenQ Keyboard V1',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk'
        },
        {
            appName: 'QOTA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/wqVfZV.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/761/QOtaClient_v2.0.3.12_V510_production.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'OfficeSuite',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/lhItsY.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/OfficeSuite.apk'
        }
    ],
    RP860K: [
        {
            appName: 'InstaQPrint',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
        },
        {
            appName: 'Maths Tutor',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk'
        },
        {
            appName: 'Seesaw',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK'
        },
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20221230/InstaShareRX_IFP_v1.4.1228-RE03-RM02-CP01-signed.apk'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/730/EAirPlay_8.11.6-benqpdp-release.apk'
        },
        {
            appName: 'Preschool and Kindergarten Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk'
        },
        {
            appName: 'Preschool and Kindergarten 2: Extra Lessons',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk'
        },
        {
            appName: 'First Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk'
        },
        {
            appName: 'Second Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk'
        },
        {
            appName: 'Third Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fourth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fifth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Sixth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk'
        },
        {
            appName: '7th Grade Math Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk'
        },
        {
            appName: 'Bingo for Kids',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl: 'https://download.teamviewer.com/blizz/android/TeamViewerBlizz.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'BenQ Keyboard V1',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk'
        },
        {
            appName: 'QOTA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/wqVfZV.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/761/QOtaClient_v2.0.3.12_V510_production.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'OfficeSuite',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/lhItsY.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/OfficeSuite.apk'
        }
    ],
    ST430K: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://dl.dropboxusercontent.com/s/2058finojudbqjz/EShareTV_v2.3.520_ST_918_Signed.apk?dl=0'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl: 'https://dl.dropboxusercontent.com/s/g66upru8jeaeusd/EAirPlay.apk?dl=0'
        }
    ],
    ST550K: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://dl.dropboxusercontent.com/s/2058finojudbqjz/EShareTV_v2.3.520_ST_918_Signed.apk?dl=0'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl: 'https://dl.dropboxusercontent.com/s/g66upru8jeaeusd/EAirPlay.apk?dl=0'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl: 'https://dl.dropboxusercontent.com/s/3gbcrjlrdj1lwil/EDLNA.apk?dl=0'
        }
    ],
    ST650K: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://dl.dropboxusercontent.com/s/2058finojudbqjz/EShareTV_v2.3.520_ST_918_Signed.apk?dl=0'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl:
                'https://dl.dropboxusercontent.com/s/cpxt3e9gs594evy/EAirPlay_5.4.15.apk?dl=0'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl: 'https://dl.dropboxusercontent.com/s/3gbcrjlrdj1lwil/EDLNA.apk?dl=0'
        }
    ],
    ST750K: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20200512/InstaShareDS-v1.2.0325-ST750K.apk'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20200512/iMirror_7.3.30.apk'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20191122/BENQDLNA_v4.4.2.apk'
        },
        {
            appName: 'CCast',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/qjI43F.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20191122/CCastV5_1.11.21.apk'
        }
    ],
    ST860K: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20200512/InstaShareDS-v1.2.0325-ST750K.apk'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20200512/iMirror_7.3.30.apk'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20191122/BENQDLNA_v4.4.2.apk'
        },
        {
            appName: 'CCast',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/qjI43F.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20191122/CCastV5_1.11.21.apk'
        }
    ],
    IL430: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20200512/InstaShareDS-v1.2.0325-IL.apk'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20200512/iMirror_7.3.30.apk'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20191122/BENQDLNA_v4.4.2.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'CCast',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/qjI43F.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20191122/CCastV5_1.11.21.apk'
        }
    ],
    IL550: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20200512/InstaShareDS-v1.2.0325-IL.apk'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20200512/iMirror_7.3.30.apk'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20191122/BENQDLNA_v4.4.2.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'CCast',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/qjI43F.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20191122/CCastV5_1.11.21.apk'
        }
    ],
    RM5501K: [
        {
            appName: 'WPS',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/h8NU4G.webp',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/WPS_Office.apk'
        },
        {
            appName: 'InstaQPrint',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
        },
        {
            appName: 'Maths Tutor',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk'
        },
        {
            appName: 'Seesaw',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK'
        },
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20230330/InstaShareRX_IFP_v1.5.0313-REL-RE01-RM03-RP03A-signed.apk'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/InstaShare/20191122/BENQDLNA_v4.4.2.apk'
        },
        {
            appName: 'Preschool and Kindergarten Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk'
        },
        {
            appName: 'Preschool and Kindergarten 2: Extra Lessons',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk'
        },
        {
            appName: 'First Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk'
        },
        {
            appName: 'Second Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk'
        },
        {
            appName: 'Third Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fourth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fifth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Sixth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk'
        },
        {
            appName: '7th Grade Math Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk'
        },
        {
            appName: 'Bingo for Kids',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'TeamViewer QuickSupport',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png',
            downloadUrl: 'https://download.teamviewer.com/download/TeamViewerQS.apk'
        },
        {
            appName: 'BenQ Keyboard V1',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk'
        },
        {
            appName: 'QOTA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/wqVfZV.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/QOtaClient_828_production.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'Kahoot! Play & Create Quizzes',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oX7Ve7.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BKB%5DKahoot+Play+and+Create+Quizzes.apk'
        },
        {
            appName: 'OfficeSuite',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/lhItsY.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/OfficeSuite.apk'
        },
        {
            appName: 'BenQ X NUADU',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/2QM2xI.jpeg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/NUADU.apk'
        }
    ],
    RM6501K: [
        {
            appName: 'WPS',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/h8NU4G.webp',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/WPS_Office.apk'
        },
        {
            appName: 'InstaQPrint',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
        },
        {
            appName: 'Maths Tutor',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk'
        },
        {
            appName: 'Seesaw',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK'
        },
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20230330/InstaShareRX_IFP_v1.5.0313-REL-RE01-RM03-RP03A-signed.apk'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/InstaShare/20191122/BENQDLNA_v4.4.2.apk'
        },
        {
            appName: 'Preschool and Kindergarten Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk'
        },
        {
            appName: 'Preschool and Kindergarten 2: Extra Lessons',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk'
        },
        {
            appName: 'First Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk'
        },
        {
            appName: 'Second Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk'
        },
        {
            appName: 'Third Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fourth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fifth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Sixth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk'
        },
        {
            appName: '7th Grade Math Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk'
        },
        {
            appName: 'Bingo for Kids',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'TeamViewer QuickSupport',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png',
            downloadUrl: 'https://download.teamviewer.com/download/TeamViewerQS.apk'
        },
        {
            appName: 'BenQ Keyboard V1',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk'
        },
        {
            appName: 'QOTA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/wqVfZV.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/QOtaClient_828_production.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'Kahoot! Play & Create Quizzes',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oX7Ve7.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/Kahoot_5.1.0.apk'
        },
        {
            appName: 'OfficeSuite',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/lhItsY.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/OfficeSuite.apk'
        },
        {
            appName: 'BenQ X NUADU',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/2QM2xI.jpeg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/NUADU.apk'
        }
    ],
    RM7501K: [
        {
            appName: 'WPS',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/h8NU4G.webp',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/WPS_Office.apk'
        },
        {
            appName: 'InstaQPrint',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
        },
        {
            appName: 'Maths Tutor',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk'
        },
        {
            appName: 'Seesaw',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK'
        },
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20230330/InstaShareRX_IFP_v1.5.0313-REL-RE01-RM03-RP03A-signed.apk'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/InstaShare/20191122/BENQDLNA_v4.4.2.apk'
        },
        {
            appName: 'Preschool and Kindergarten Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk'
        },
        {
            appName: 'Preschool and Kindergarten 2: Extra Lessons',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk'
        },
        {
            appName: 'First Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk'
        },
        {
            appName: 'Second Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk'
        },
        {
            appName: 'Third Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fourth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fifth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Sixth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk'
        },
        {
            appName: '7th Grade Math Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk'
        },
        {
            appName: 'Bingo for Kids',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'TeamViewer QuickSupport',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png',
            downloadUrl: 'https://download.teamviewer.com/download/TeamViewerQS.apk'
        },
        {
            appName: 'BenQ Keyboard V1',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk'
        },
        {
            appName: 'QOTA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/wqVfZV.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/QOtaClient_828_production.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'Kahoot! Play & Create Quizzes',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oX7Ve7.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/Kahoot!.apk'
        },
        {
            appName: 'OfficeSuite',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/lhItsY.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/OfficeSuite.apk'
        },
        {
            appName: 'BenQ X NUADU',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/2QM2xI.jpeg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/NUADU.apk'
        }
    ],
    RM8601K: [
        {
            appName: 'WPS',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/h8NU4G.webp',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/WPS_Office.apk'
        },
        {
            appName: 'InstaQPrint',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
        },
        {
            appName: 'Maths Tutor',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk'
        },
        {
            appName: 'Seesaw',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK'
        },
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20230330/InstaShareRX_IFP_v1.5.0313-REL-RE01-RM03-RP03A-signed.apk'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/InstaShare/20191122/BENQDLNA_v4.4.2.apk'
        },
        {
            appName: 'Preschool and Kindergarten Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk'
        },
        {
            appName: 'Preschool and Kindergarten 2: Extra Lessons',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk'
        },
        {
            appName: 'First Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk'
        },
        {
            appName: 'Second Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk'
        },
        {
            appName: 'Third Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fourth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Fifth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk'
        },
        {
            appName: 'Sixth Grade Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk'
        },
        {
            appName: '7th Grade Math Learning Games',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk'
        },
        {
            appName: 'Bingo for Kids',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'TeamViewer QuickSupport',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png',
            downloadUrl: 'https://download.teamviewer.com/download/TeamViewerQS.apk'
        },
        {
            appName: 'BenQ Keyboard V1',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk'
        },
        {
            appName: 'QOTA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/wqVfZV.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/QOtaClient_828_production.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'Kahoot! Play & Create Quizzes',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oX7Ve7.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/Kahoot_v5.9.3.1-2799.apk'
        },
        {
            appName: 'OfficeSuite',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/lhItsY.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/OfficeSuite.apk'
        },
        {
            appName: 'BenQ X NUADU',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/2QM2xI.jpeg',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/NUADU.apk'
        }
    ],
    RP6501K: [
        {
            appName: "WPS",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/h8NU4G.webp",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/WPS_Office.apk"
        },
        {
            appName: "InstaQPrint",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk"
        },
        {
            appName: "Maths Tutor",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk"
        },
        {
            appName: "Seesaw",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK"
        },
        {
            appName: "InstaShare",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20230330/InstaShareRX_IFP_v1.5.0313-REL-RP01K-signed.apk"
        },
        {
            appName: "Preschool and Kindergarten Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk"
        },
        {
            appName: "Preschool and Kindergarten 2: Extra Lessons",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk"
        },
        {
            appName: "First Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk"
        },
        {
            appName: "Second Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk"
        },
        {
            appName: "Third Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk"
        },
        {
            appName: "Fourth Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk"
        },
        {
            appName: "Fifth Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk"
        },
        {
            appName: "Sixth Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk"
        },
        {
            appName: "7th Grade Math Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk"
        },
        {
            appName: "Bingo for Kids",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk"
        },
        {
            appName: "VMware Horizon Client",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk"
        },
        {
            appName: "TeamViewer Meeting",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png",
            downloadUrl: "https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk"
        },
        {
            appName: "broadcast setting",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk"
        },
        {
            appName: "TeamViewer QuickSupport",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png",
            downloadUrl: "https://download.teamviewer.com/download/TeamViewerQS.apk"
        },
        {
            appName: "BenQ Keyboard V1",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk"
        },
        {
            appName: "EZWrite5",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/1cgpzZ.png",
            downloadUrl: "https://qspublic.s3.ap-southeast-1.amazonaws.com/qspublic/qs_app/760/EZWrite5-v1.2.0.12%2849%29-RP01K-release.apk"
        },
        {
            appName: "Firefox",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/vA7dfb.png",
            downloadUrl: "https://github.com/mozilla-mobile/fenix/releases/download/v98.3.0/fenix-98.3.0-arm64-v8a.apk"
        },
        {
            appName: "Saffi",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/V3s3jo.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/Saffi/saffi_RP01.apk"
        },
        {
            appName: "McAfee Mobile Security",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk"
        },
        {
            appName: "AMS",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/AjxjV4.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/AMS/v2.0.3.1/RP01/AMS_FM_ProductionRP01_v2.0.3.1_release.apk"
        },
        {
            appName: "Oak National Academy",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/OiAJQc.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/OakNational_w.apk"
        },
        {
            appName: "Kahoot! Play & Create Quizzes",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oX7Ve7.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/Kahoot.apk"
        },
        {
            appName: "MangaChat Play",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/nKj7VI.jpeg",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/mangaChatPlay.apk"
        },
        {
            appName: "Bouncy Balls",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/NyiVah.jpg",
            downloadUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/qspublic/qs_app/912/1656905595739_Bouncyballs_v0.0.0.2.apk"
        },
        {
            appName: "OfficeSuite",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/lhItsY.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/OfficeSuite.apk"
        },
        {
            appName: "BenQ X NUADU",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/2QM2xI.jpeg",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/NUADU.apk"
        }
    ],
    RP7501K: [
        {
            appName: "WPS",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/h8NU4G.webp",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/WPS_Office.apk"
        },
        {
            appName: "InstaQPrint",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk"
        },
        {
            appName: "Maths Tutor",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk"
        },
        {
            appName: "Seesaw",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK"
        },
        {
            appName: "InstaShare",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20230330/InstaShareRX_IFP_v1.5.0313-REL-RP01K-signed.apk"
        },
        {
            appName: "Preschool and Kindergarten Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk"
        },
        {
            appName: "Preschool and Kindergarten 2: Extra Lessons",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk"
        },
        {
            appName: "First Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk"
        },
        {
            appName: "Second Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk"
        },
        {
            appName: "Third Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk"
        },
        {
            appName: "Fourth Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk"
        },
        {
            appName: "Fifth Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk"
        },
        {
            appName: "Sixth Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk"
        },
        {
            appName: "7th Grade Math Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk"
        },
        {
            appName: "Bingo for Kids",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk"
        },
        {
            appName: "VMware Horizon Client",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk"
        },
        {
            appName: "TeamViewer Meeting",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png",
            downloadUrl: "https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk"
        },
        {
            appName: "broadcast setting",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk"
        },
        {
            appName: "TeamViewer QuickSupport",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png",
            downloadUrl: "https://download.teamviewer.com/download/TeamViewerQS.apk"
        },
        {
            appName: "BenQ Keyboard V1",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk"
        },
        {
            appName: "EZWrite5",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/1cgpzZ.png",
            downloadUrl: "https://qspublic.s3.ap-southeast-1.amazonaws.com/qspublic/qs_app/760/EZWrite5-v1.2.0.12%2849%29-RP01K-release.apk"
        },
        {
            appName: "Firefox",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/vA7dfb.png",
            downloadUrl: "https://github.com/mozilla-mobile/fenix/releases/download/v98.3.0/fenix-98.3.0-arm64-v8a.apk"
        },
        {
            appName: "Saffi",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/V3s3jo.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/Saffi/saffi_RP01.apk"
        },
        {
            appName: "McAfee Mobile Security",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk"
        },
        {
            appName: "AMS",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/AjxjV4.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/AMS/v2.0.3.1/RP01/AMS_FM_ProductionRP01_v2.0.3.1_release.apk"
        },
        {
            appName: "Oak National Academy",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/OiAJQc.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/OakNational_w.apk"
        },
        {
            appName: "Kahoot! Play & Create Quizzes",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oX7Ve7.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/Kahoot.apk"
        },
        {
            appName: "MangaChat Play",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/nKj7VI.jpeg",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/mangaChatPlay.apk"
        },
        {
            appName: "Bouncy Balls",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/NyiVah.jpg",
            downloadUrl: "https://qspublic.s3.ap-southeast-1.amazonaws.com/qspublic/qs_app/912/1656905595739_Bouncyballs_v0.0.0.2.apk"
        },
        {
            appName: "OfficeSuite",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/lhItsY.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/OfficeSuite.apk"
        },
        {
            appName: "BenQ X NUADU",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/2QM2xI.jpeg",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/NUADU.apk"
        }
    ],
    RP8601K: [
        {
            appName: "WPS",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/h8NU4G.webp",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/WPS_Office.apk"
        },
        {
            appName: "InstaQPrint",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk"
        },
        {
            appName: "Maths Tutor",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/P0jaGx.webp",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BDaydream%5Dmaths-tutor.apk"
        },
        {
            appName: "Seesaw",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gUWKzw.jpg",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BSeesaw%5Dapp-classroom-release.APK"
        },
        {
            appName: "InstaShare",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20230330/InstaShareRX_IFP_v1.5.0313-REL-RP01K-signed.apk"
        },
        {
            appName: "Preschool and Kindergarten Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/XGW4LT.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+Learning+Games.apk"
        },
        {
            appName: "Preschool and Kindergarten 2: Extra Lessons",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/BbHvih.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DPreschool+and+Kindergarten+2_+Extra+Lessons.apk"
        },
        {
            appName: "First Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/MINNMr.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFirst+Grade+Learning+Games.apk"
        },
        {
            appName: "Second Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/SgrJgz.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSecond+Grade+Learning+Games.apk"
        },
        {
            appName: "Third Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/R53jec.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DThird+Grade+Learning+Games.apk"
        },
        {
            appName: "Fourth Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/cpWjyR.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFourth+Grade+Learning+Games.apk"
        },
        {
            appName: "Fifth Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/f97Wa7.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DFifth+Grade+Learning+Games.apk"
        },
        {
            appName: "Sixth Grade Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oAkdeI.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DSixth+Grade+Learning+Games.apk"
        },
        {
            appName: "7th Grade Math Learning Games",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/43vWzm.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5D7th+Grade+Math+Learning+Games.apk"
        },
        {
            appName: "Bingo for Kids",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/ZRNM9E.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BKB%5DBingo+for+Kids.apk"
        },
        {
            appName: "VMware Horizon Client",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk"
        },
        {
            appName: "TeamViewer Meeting",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png",
            downloadUrl: "https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk"
        },
        {
            appName: "broadcast setting",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk"
        },
        {
            appName: "TeamViewer QuickSupport",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png",
            downloadUrl: "https://download.teamviewer.com/download/TeamViewerQS.apk"
        },
        {
            appName: "BenQ Keyboard V1",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/7A7X5s.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/%5BHonso%5DBenQKeyboard.apk"
        },
        {
            appName: "EZWrite5",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/1cgpzZ.png",
            downloadUrl: "https://qspublic.s3.ap-southeast-1.amazonaws.com/qspublic/qs_app/760/EZWrite5-v1.2.0.12%2849%29-RP01K-release.apk"
        },
        {
            appName: "Firefox",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/vA7dfb.png",
            downloadUrl: "https://github.com/mozilla-mobile/fenix/releases/download/v98.3.0/fenix-98.3.0-arm64-v8a.apk"
        },
        {
            appName: "Saffi",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/V3s3jo.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/Saffi/saffi_RP01.apk"
        },
        {
            appName: "McAfee Mobile Security",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk"
        },
        {
            appName: "AMS",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/AjxjV4.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/AMS/v2.0.3.1/RP01/AMS_FM_ProductionRP01_v2.0.3.1_release.apk"
        },
        {
            appName: "Oak National Academy",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/OiAJQc.png",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/OakNational_w.apk"
        },
        {
            appName: "Kahoot! Play & Create Quizzes",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/oX7Ve7.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/Kahoot.apk"
        },
        {
            appName: "MangaChat Play",
            iconUrl: "https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/nKj7VI.jpeg",
            downloadUrl: "https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/mangaChatPlay.apk"
        },
        {
            appName: "Bouncy Balls",
            iconUrl: "https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/NyiVah.jpg",
            downloadUrl: "https://qspublic.s3.ap-southeast-1.amazonaws.com/qspublic/qs_app/912/1656905595739_Bouncyballs_v0.0.0.2.apk"
        },
        {
            appName: "OfficeSuite",
            iconUrl: "https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/lhItsY.png",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/OfficeSuite.apk"
        },
        {
            appName: "BenQ X NUADU",
            iconUrl: "https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/2QM2xI.jpeg",
            downloadUrl: "https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/NUADU.apk"
        }
    ],
    ST4301K: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20201203/InstaShareDS_v1.2.1124-REL-ST01K_Signed.apk'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20201203/iMirror_7.10.31.f.apk'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20201203/BENQEDLNA_v4.4.2.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'CCast',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/qjI43F.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20201203/CCast_2.11.11.apk'
        }
    ],
    ST5501K: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20201203/InstaShareDS_v1.2.1124-REL-ST01K_Signed.apk'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20201203/iMirror_7.10.31.f.apk'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20201203/BENQEDLNA_v4.4.2.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'CCast',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/qjI43F.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20201203/CCast_2.11.11.apk'
        }
    ],
    SL6501: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20200512/InstaShareDS-v1.2.0325-IL.apk'
        },
        {
            appName: 'iMirror',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FRX1wR.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20200512/iMirror_7.3.30.apk'
        },
        {
            appName: 'EDLNA',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/gQQzDm.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20191122/BENQDLNA_v4.4.2.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'CCast',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/qjI43F.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20191122/CCastV5_1.11.21.apk'
        }
    ],
    ST4302: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20221230/InstaShareRX_DS_v1.4.1229-ST02-signed.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'TeamViewer QuickSupport',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png',
            downloadUrl: 'https://download.teamviewer.com/download/TeamViewerQS.apk'
        },
        {
            appName: 'Firefox',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/vA7dfb.png',
            downloadUrl:
                'https://github.com/mozilla-mobile/fenix/releases/download/v98.3.0/fenix-98.3.0-arm64-v8a.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'BenQ Keyboard',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/3RNx53.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/866/BenQKeyboard_3.0.0.15.apk'
        },
        {
            appName: 'Vivi Receiver',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/zWL2Sj.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/ViviReceiverApp.apk'
        }
    ],
    ST5502: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20221230/InstaShareRX_DS_v1.4.1229-ST02-signed.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'TeamViewer QuickSupport',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png',
            downloadUrl: 'https://download.teamviewer.com/download/TeamViewerQS.apk'
        },
        {
            appName: 'Firefox',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/vA7dfb.png',
            downloadUrl:
                'https://github.com/mozilla-mobile/fenix/releases/download/v98.3.0/fenix-98.3.0-arm64-v8a.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'BenQ Keyboard',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/3RNx53.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/866/BenQKeyboard_3.0.0.15.apk'
        },
        {
            appName: 'Vivi Receiver',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/zWL2Sj.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/ViviReceiverApp.apk'
        }
    ],
    ST6502: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20221230/InstaShareRX_DS_v1.4.1229-ST02-signed.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'TeamViewer QuickSupport',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png',
            downloadUrl: 'https://download.teamviewer.com/download/TeamViewerQS.apk'
        },
        {
            appName: 'Firefox',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/vA7dfb.png',
            downloadUrl:
                'https://github.com/mozilla-mobile/fenix/releases/download/v98.3.0/fenix-98.3.0-arm64-v8a.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'BenQ Keyboard',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/3RNx53.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/866/BenQKeyboard_3.0.0.15.apk'
        },
        {
            appName: 'Vivi Receiver',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/zWL2Sj.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/ViviReceiverApp.apk'
        }
    ],
    ST7502: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20221230/InstaShareRX_DS_v1.4.1229-ST02-signed.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'TeamViewer QuickSupport',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png',
            downloadUrl: 'https://download.teamviewer.com/download/TeamViewerQS.apk'
        },
        {
            appName: 'Firefox',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/vA7dfb.png',
            downloadUrl:
                'https://github.com/mozilla-mobile/fenix/releases/download/v98.3.0/fenix-98.3.0-arm64-v8a.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'BenQ Keyboard',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/3RNx53.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/866/BenQKeyboard_3.0.0.15.apk'
        },
        {
            appName: 'Vivi Receiver',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/zWL2Sj.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/ViviReceiverApp.apk'
        }
    ],
    ST8602: [
        {
            appName: 'InstaShare',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/znisTl.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/InstaShare/20221230/InstaShareRX_DS_v1.4.1229-ST02-signed.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'broadcast setting',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/YpNu8n.png',
            downloadUrl:
                'https://cmota.s3-ap-northeast-1.amazonaws.com/BenQSuggestMaterial/XSign/BroadcastPlayer-2.4.1.2-041000-production-release-signed.apk'
        },
        {
            appName: 'TeamViewer QuickSupport',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/FTspjI.png',
            downloadUrl: 'https://download.teamviewer.com/download/TeamViewerQS.apk'
        },
        {
            appName: 'Firefox',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/vA7dfb.png',
            downloadUrl:
                'https://github.com/mozilla-mobile/fenix/releases/download/v98.3.0/fenix-98.3.0-arm64-v8a.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'BenQ Keyboard',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/3RNx53.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/866/BenQKeyboard_3.0.0.15.apk'
        },
        {
            appName: 'Vivi Receiver',
            iconUrl: 'https://qspublic.s3.ap-southeast-1.amazonaws.com/small_icon/zWL2Sj.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/3rdParty/ViviReceiverApp.apk'
        }
    ],
    CS6501: [
        {
            appName: 'InstaQPrint',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'Firefox',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/vA7dfb.png',
            downloadUrl:
                'https://github.com/mozilla-mobile/fenix/releases/download/v98.3.0/fenix-98.3.0-arm64-v8a.apk'
        },
        {
            appName: 'Saffi',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/V3s3jo.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/Saffi/saffi_CS.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'InstaShare2 Host',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/nH8bh6.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/InstaShare2/20221227_v.1.4.27.8/host/20221227/instashare2_host_cvte_1.4.27.8_1_production.apk'
        },
        {
            appName: 'BenQ Keyboard',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/3RNx53.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/866/BenQKeyboard_3.0.0.15.apk'
        }
    ],
    CS7501: [
      {
        appName: 'InstaQPrint',
        iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
        downloadUrl:
            'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
      },
      {
          appName: 'VMware Horizon Client',
          iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
          downloadUrl:
              'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
      },
      {
          appName: 'TeamViewer Meeting',
          iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
          downloadUrl:
              'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
      },
      {
          appName: 'Firefox',
          iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/vA7dfb.png',
          downloadUrl:
              'https://github.com/mozilla-mobile/fenix/releases/download/v98.3.0/fenix-98.3.0-arm64-v8a.apk'
      },
      {
          appName: 'Saffi',
          iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/V3s3jo.png',
          downloadUrl:
              'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/Saffi/saffi_CS.apk'
      },
      {
          appName: 'McAfee Mobile Security',
          iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
          downloadUrl:
              'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
      },
      {
          appName: 'InstaShare2 Host',
          iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/nH8bh6.png',
          downloadUrl:
              'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/InstaShare2/20221227_v.1.4.27.8/host/20221227/instashare2_host_cvte_1.4.27.8_1_production.apk'
      },
      {
          appName: 'BenQ Keyboard',
          iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/3RNx53.png',
          downloadUrl:
              'http://qspublic.s3.amazonaws.com/qspublic/qs_app/866/BenQKeyboard_3.0.0.15.apk'
      }
    ],
    CS8601: [
        {
            appName: 'InstaQPrint',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/KtzxCO.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BInstaQPrint%5D+PrintHand.apk'
        },
        {
            appName: 'VMware Horizon Client',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/c7bZyu.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/%5BVMware%5DVMware-Horizon-Client-AndroidOS-arm64.apk'
        },
        {
            appName: 'TeamViewer Meeting',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/o0btWp.png',
            downloadUrl:
                'https://dl.teamviewer.com/teamviewermeeting/android/TeamViewerMeeting.apk'
        },
        {
            appName: 'Firefox',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/vA7dfb.png',
            downloadUrl:
                'https://github.com/mozilla-mobile/fenix/releases/download/v98.3.0/fenix-98.3.0-arm64-v8a.apk'
        },
        {
            appName: 'Saffi',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/V3s3jo.png',
            downloadUrl:
                'https://d2fqxlpnusiysx.cloudfront.net/BenQSuggestMaterial/Saffi/saffi_CS.apk'
        },
        {
            appName: 'McAfee Mobile Security',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/6PzslL.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/3rdParty/McAfee_MMS.apk'
        },
        {
            appName: 'InstaShare2 Host',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/nH8bh6.png',
            downloadUrl:
                'https://cmota.s3.ap-northeast-1.amazonaws.com/BenQSuggestMaterial/InstaShare2/20221227_v.1.4.27.8/host/20221227/instashare2_host_cvte_1.4.27.8_1_production.apk'
        },
        {
            appName: 'BenQ Keyboard',
            iconUrl: 'https://qspublic.s3-ap-southeast-1.amazonaws.com/small_icon/3RNx53.png',
            downloadUrl:
                'http://qspublic.s3.amazonaws.com/qspublic/qs_app/866/BenQKeyboard_3.0.0.15.apk'
        }
    ]
};

export default modelList;
